define( [
	"./core",
	"./attributes/attr",
	"./attributes/prop",
	"./attributes/classes",
	"./attributes/val"
], function( jQuery ) {

// Return jQuery for attributes-only inclusion
return jQuery;
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/attributes.js
 ** module id = 476
 ** module chunks = 2
 **/